import { render, staticRenderFns } from "./Estudio.vue?vue&type=template&id=96bd432e&"
import script from "./Estudio.vue?vue&type=script&lang=js&"
export * from "./Estudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports